import React from "react";
import classes from "./MatchEvents2.module.css";

const MatchEvents2 = ({ team_name, data }) => {
    return (
        <div className={classes.panel_container}>
            <div className={classes.panel_header}>
                <p className={classes.panel_header_heading}>{team_name}</p>
            </div>
            {data?.length > 0 ? (
                data.map((dataItem, index) => (
                    <div className={classes.container} key={index}>
                        <p className={classes.name}>{dataItem?.player?.name}</p>
                        <p className={classes.time}>{dataItem?.time?.elapsed}`</p>
                    </div>
                ))
            ) : (
                <p className={classes.empty}>No goals yet…</p>
            )}
        </div>
    );
};

export default MatchEvents2;